module.exports = __webpack_public_path__ + "media/images/recipes/ribeye-75eef70c821689490a3d24c1d4a301e3.pdf";